import type { CommunicationTabValue } from './types';
import type { InterviewCommunicationValidationErrors } from './validate';

type ScrollTarget = {
  sectionId: string;
  tab: CommunicationTabValue;
};

const ERROR_SCROLL_ORDER: Array<{
  key: keyof InterviewCommunicationValidationErrors;
  sectionId: string;
  tab: CommunicationTabValue;
}> = [
  {
    key: 'candidateCalendar',
    sectionId: 'interview-comm-candidate-calendar',
    tab: 'candidate-communication',
  },
  {
    key: 'candidateEmail',
    sectionId: 'interview-comm-candidate-email',
    tab: 'candidate-communication',
  },
  {
    key: 'interviewerCalendar',
    sectionId: 'interview-comm-interviewer-calendar',
    tab: 'interviewer-communication',
  },
  {
    key: 'interviewerEmail',
    sectionId: 'interview-comm-interviewer-email',
    tab: 'interviewer-communication',
  },
  {
    key: 'selfSchedule',
    sectionId: 'interview-comm-self-schedule',
    tab: 'self-schedule-slot-selection-email',
  },
];

export function getFirstCommunicationErrorScrollTarget(
  errors: InterviewCommunicationValidationErrors
): ScrollTarget | null {
  for (const { key, sectionId, tab } of ERROR_SCROLL_ORDER) {
    if (errors[key]) {
      return { sectionId, tab };
    }
  }
  return null;
}

export function scrollCommunicationSectionIntoView(sectionId: string): void {
  const el = document.getElementById(sectionId);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
